import * as CryptoJS from 'crypto-js';
import { OrganizationData } from '../models/organization.model';
import { userDetailModel } from '../../features/organizations/organization.interface';

export const SECRET_KEY = '725a0e9c-1286-411d-b598-5943a6308f0f';

/**
 * Decrypts encrypted data using AES encryption
 * @param encryptedData The encrypted data string
 * @param secretKey The secret key used for decryption (optional, uses default if not provided)
 * @returns Decrypted data object or null if decryption fails
 */
export function decryptData<T>(
  encryptedData: string,
  secretKey: string = SECRET_KEY
): T | null {
  if (!encryptedData) {
    return null;
  }

  try {
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  } catch (error) {
    console.error('Error decrypting data:', error);
    return null;
  }
}

/**
 * Encrypts data using AES encryption
 * @param data The data to encrypt
 * @param secretKey The secret key used for encryption (optional, uses default if not provided)
 * @returns Encrypted data string or null if encryption fails
 */
export function encryptData(
  data: unknown,
  secretKey: string = SECRET_KEY
): string | null {
  if (!data) {
    return null;
  }

  try {
    const jsonString = JSON.stringify(data);
    return CryptoJS.AES.encrypt(jsonString, secretKey).toString();
  } catch (error) {
    console.error('Error encrypting data:', error);
    return null;
  }
}

/**
 * Loads organization data from localStorage
 * @param storageKey The localStorage key to retrieve (default: 'Selected_Org_Data')
 * @returns Decrypted organization data or null
 */
export function loadOrganizationData(
  storageKey = 'Selected_Org_Data'
): OrganizationData | null {
  try {
    const encryptedOrgData = localStorage.getItem(storageKey);
    if (encryptedOrgData) {
      return decryptData<OrganizationData>(encryptedOrgData);
    }
    return null;
  } catch (error) {
    console.error('Error loading organization data:', error);
    return null;
  }
}

/**
 * Loads user data from localStorage
 * @param storageKey The localStorage key to retrieve (default: 'user_data')
 * @returns Decrypted user data or null
 * */

export function loadUserData(storageKey = 'user_data'): userDetailModel | null {
  try {
    const encryptedOrgData = localStorage.getItem(storageKey);
    if (encryptedOrgData) {
      return decryptData<userDetailModel>(encryptedOrgData);
    }
    return null;
  } catch (error) {
    console.error('Error loading organization data:', error);
    return null;
  }
}
